export enum PlanningMode {
  Calendar = "Calendar",
  Agenda = "Agenda",
  Schedule = "Schedule",
  Timeline = "Timeline",
}
